// src/vatandas/utils/safeNext.js  (FAZ-63)
//
// Giriş sonrası yönlendirme hedefinin ("next") güvenlik süzgeci.
//
// NEDEN VAR: SMS'teki kısa link tıklanınca kullanıcı giriş sayfasına düşüyor ve
// girişten sonra hedefine dönüyor. Hedef URL'den okunduğu için, süzülmezse klasik
// bir AÇIK YÖNLENDİRME (open redirect) açığı olur:
//
//     /giris?next=https://sahte-site.example/giris
//     → kullanıcı giriş yaptığını sanır, kimlik bilgisini saldırgana yazar.
//
// Kural: SADECE kendi sitemizde kalan göreli yollar kabul edilir.

/**
 * Metinde kontrol karakteri (satır sonu, boş bayt vb.) var mı?
 * Regex'te kontrol karakteri LİTERALİ kullanmıyoruz — kaynak dosyaya görünmez
 * bayt kaçması riski var; kod noktasıyla karşılaştırmak hem güvenli hem okunur.
 */
function hasControlChar(text) {
  for (let i = 0; i < text.length; i += 1) {
    const code = text.charCodeAt(i);
    if (code < 0x20 || code === 0x7f) return true;
  }
  return false;
}

/**
 * Bir "next" değerini güvenli göreli yola indirger.
 *
 * Kabul: "/yonetim/gorevler/12", "/yonetim/gorevlerim?kume=acik"
 * Ret  : "https://dis.site/x", "//dis.site/x", "javascript:alert(1)",
 *        "yonetim/gorevler" (baştaki / yok), boş/metin olmayan değerler
 *
 * @param {unknown} value ham next değeri
 * @returns {string} güvenliyse yolun kendisi, değilse "" (çağıran varsayılana düşer)
 */
export function safeNextPath(value) {
  if (typeof value !== "string") return "";

  const raw = value.trim();
  if (!raw) return "";

  // Tek bir "/" ile başlamalı — "//host" protokolsüz dış adrestir.
  if (!raw.startsWith("/")) return "";
  if (raw.startsWith("//")) return "";

  // "\" bazı tarayıcılarda "/" gibi çözülür → "/\evil.com" dış adres olabilir.
  if (raw.startsWith("/\\")) return "";

  // Şema enjeksiyonu ("javascript:", "data:") ve kimlik bilgili adresler.
  // Yolun kendisinde ":" veya "@" olmasına ihtiyacımız yok; reddetmek güvenli.
  const beforeQuery = raw.split(/[?#]/)[0];
  if (beforeQuery.includes(":") || beforeQuery.includes("@")) return "";

  if (hasControlChar(raw)) return "";

  return raw;
}

/**
 * Mevcut konumdan giriş sayfası adresi üretir: "/giris?next=<encode(hedef)>"
 *
 * @param {string} pathname
 * @param {string} [search]
 * @returns {string}
 */
export function loginUrlWithNext(pathname, search = "") {
  const target = safeNextPath(`${pathname || ""}${search || ""}`);
  if (!target) return "/giris";
  return `/giris?next=${encodeURIComponent(target)}`;
}
